// types
import { IFG_HeatingSetpoint } from './types'
// components
import { ChildrenView } from '../../components/ChildrenView'


export function OperatorPanel(props: IFG_HeatingSetpoint) {

    return (
        <ChildrenView resourceGroupId={props.resourceGroupId} parentId={props.id} />
    );
}

